import { render, staticRenderFns } from "./gb-ant-select-multiple-cascader.vue?vue&type=template&id=12518d5a&scoped=true&"
import script from "./gb-ant-select-multiple-cascader.vue?vue&type=script&lang=js&"
export * from "./gb-ant-select-multiple-cascader.vue?vue&type=script&lang=js&"
import style0 from "./gb-ant-select-multiple-cascader.vue?vue&type=style&index=0&lang=less&"
import style1 from "./gb-ant-select-multiple-cascader.vue?vue&type=style&index=1&id=12518d5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12518d5a",
  null
  
)

export default component.exports